module.exports = __webpack_public_path__ + "img/shouqianshou.0785f0e9.png";